import {Dimensions, StyleSheet} from 'react-native';
import {colorPalette, textStyles} from '../../../../theme';

export default StyleSheet.create({
  scrollStyle: {
    flex: 1,
  },
  scroll: { 
    flex: 1,
    // backgroundColor : 'red' ,
  },
  content : {
      height : Dimensions.get('window').height * 0.8 - 20 ,
      justifyContent : 'space-between' ,
  },
  mainIcon: {
    justifyContent: 'center',
    alignItems: 'center',
    marginTop: 16,
    marginBottom: 14,
    backgroundColor: colorPalette.whiteGrey0,
    alignSelf: 'center',
    borderRadius: 1000,
    elevation: 10,
    shadowColor: 'rgba(0, 0, 0, 0.25)',
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowOpacity: 1,
    shadowRadius: 3,
    height: 64,
    width: 64,
  },
  mainTitle: {
    fontFamily: textStyles.bold,
    fontSize: 16,
    color: colorPalette.grey7,
    textAlign: 'center',
    marginBottom: 12,
  },
  checkButton: {
    marginHorizontal: 16,
    marginBottom: 10,
    marginTop: 20,
    backgroundColor: colorPalette.whiteGrey0,
    borderWidth: 1,
    borderColor: colorPalette.grey2,
  },
  checkButtonTitle: {
    fontFamily: textStyles.medium,
    color: colorPalette.grey8_5,
  },
  mapButton: {
    marginHorizontal: 16,
    marginBottom: 20,
  },
});
